import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createALLCallHistorySlice = (set, get) => ({
    crmAllCallHistory: {
        loading: false,
        data: [],
    },
    getCrmAllCallHistory: async (params) => {
        const { param } = params;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmAllCallHistory: { ...state.crmAllCallHistory, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: `/v1/crm/call-histories/null/${param.FromDate}/${param.ToDate}`,
                headers: { token },
            });
            set(state => ({ crmAllCallHistory: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmAllCallHistory: { ...state.crmAllCallHistory, loading: false } }));
        }
    }
});
